/**
 * The case's activities, shared between the two things on the case detail page
 * that need them.
 *
 * WHY THIS EXISTS
 * ---------------
 * The Progress Tracker fetches `apiGetActivities({ caseId })` to draw its log,
 * and the Activities dialog fetched the SAME list again from scratch when it
 * opened — so every open sat on a loader waiting for a round trip whose answer
 * was already on the page. That is the wait Usman saw.
 *
 * Whichever gets there first fills this; the dialog opens from it immediately
 * and still revalidates behind the scenes, so a list changed from the schedule
 * board in another tab corrects itself a moment later rather than being trusted
 * forever.
 *
 * DELIBERATELY NOT A STATE LIBRARY. One Map, one key, no subscriptions: the
 * only readers are two components on one page, and the cost of being wrong is a
 * list that is a second stale, not a bad write.
 */

const cache = new Map()

/** The rows for a case, or undefined when nothing has fetched them yet. */
export function getCachedCaseActivities(caseId) {
    if (caseId == null) return undefined
    return cache.get(String(caseId))
}

export function setCachedCaseActivities(caseId, rows) {
    if (caseId == null || !Array.isArray(rows)) return
    cache.set(String(caseId), rows)
}

/** After a write, so the next reader fetches rather than trusting this. */
export function invalidateCaseActivities(caseId) {
    if (caseId == null) {
        cache.clear()
        return
    }
    cache.delete(String(caseId))
}
